import nameModelValidator from 'forms/shared/validators/models/name/name';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { ValidateJSModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { foreignContactRelationshipOptions, foreignInterestCoOwnerOptions } from 'constants/enums/foreignActivityOptions';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { isSafeUnitedStates } from 'helpers/locations';
import { ForeignActivitiesCoOwnerItemModel } from './foreignActivitiesCoOwner';

const foreignCoOwnerItemValidator: ValidateJSModel<ForeignActivitiesCoOwnerItemModel> = {
  Name: { presence: true, model: { validator: nameModelValidator } },

  Address: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.AddressNotApplicable?.applicable === false
        || attributes?.InUsNotApplicable?.applicable === false) {
        return {};
      }
      return {
        presence: true,
        location: {
          validator: pvqLocationModelValidator,
          requireStreet: true,
          requireIsMilitaryDiplomaticAddress: true,
          requireMilitaryDiplomaticInstallationName: isSafeUnitedStates(value),
          requireApoFpoDpoPostcode: !isSafeUnitedStates(value),

        },

      };
    }
    return {
      presence: true,
      location: { validator: locationAddressModelValidator }
    };
  },

  Countries: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.CountryNotApplicable?.applicable === false) {
      return {};
    }
    return { hasValue: true, country: true };
  },

  RelationshipNature: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { hasValue: true };
  },

  // pvq only

  Relationship: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.RelationshipNotApplicable?.applicable !== false) {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: foreignContactRelationshipOptions,
            },
          },
        },
      };
    }
    return {};
  },

  CoOwnerTypeOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.CoOwnerType?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  CoOwnerType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: foreignInterestCoOwnerOptions,
            },
          },
        },
      };
    }
    return {};
  },

};
export default foreignCoOwnerItemValidator;
